module.exports = "<div class=\"jumbotron\">\n    <h1 class=\"display-4\">Angular Playground</h1>\n    <p class=\"lead\">Developer: Vanz Perla</p>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/admin/Documents/Visual Studio 2017/Projects/VanzAngularEcommerce/src/app/about/about.component.html
// module id = ../../../../../src/app/about/about.component.html
// module chunks = 1